import switchFunc from 'lib/switchFunc'

import { PACKAGE_UPGRADE_DISPLAY_TEXT } from 'constants/tours'

export const TOUR_V2_ROOM_TYPE: Partial<Record<Tours.V2OfferRoomType, string>> = {
  single_regular: PACKAGE_UPGRADE_DISPLAY_TEXT.REGULAR,
  twin_regular: PACKAGE_UPGRADE_DISPLAY_TEXT.REGULAR,
  single_vip: PACKAGE_UPGRADE_DISPLAY_TEXT.VIP,
  twin_vip: PACKAGE_UPGRADE_DISPLAY_TEXT.VIP,
  single_platinum: PACKAGE_UPGRADE_DISPLAY_TEXT.PLATINUM,
  twin_platinum: PACKAGE_UPGRADE_DISPLAY_TEXT.PLATINUM,
}

const formatPackageOptionType = switchFunc(TOUR_V2_ROOM_TYPE, '')

export default formatPackageOptionType
